import React from 'react';
import { useField, ErrorMessage } from 'formik';
import { FormControlLabel, Link, Typography, Checkbox } from '@mui/material';

export interface CustomCheckBoxWithTextProps {
  name: string;
  text: string;
  labelPlacement: 'end' | 'start' | 'top' | 'bottom';
  href?: string;
  targetPage?: string;
  hrefText?: string;
}

export const CustomCheckBoxWithText: React.FC<CustomCheckBoxWithTextProps> = ({
  name,
  labelPlacement,
  text,
  href,
  targetPage,
  hrefText,
}) => {
  const [field] = useField(name);

  return (
    <>
      <FormControlLabel
        sx={{ marginLeft: 0 }}
        control={<Checkbox {...field} checked={field.value} />}
        label={
          <>
            {text}
            {href && hrefText && (
              <Link href={href} target={targetPage}>
                {hrefText}
              </Link>
            )}
          </>
        }
        labelPlacement={labelPlacement}
      />

      <ErrorMessage
        name={name}
        render={(errorMessage) => (
          <Typography
            color="error"
            variant="body2"
            sx={{
              margin: '4px 12px 0 12px',
            }}
          >
            {errorMessage}
          </Typography>
        )}
      />
    </>
  );
};
